var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoXlsx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "4.11458in",
    height: "4.51667in",
    viewBox: "0 0 1259 1382",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 50.9909,
    strokeLinejoin: "round",
    points: "155,25 891,25 1104,238 1104,1356 155,1356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 42.4918,
    strokeLinejoin: "round",
    d: "M891 25l213 213 -107 0c-58,0 -106,-48 -106,-106l0 -107z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1D7649",
    y: 573,
    width: 1259,
    height: 599,
    rx: 43,
    ry: 43
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "158,1002 247,867 166,743 227,743 278,820 329,743 390,743 309,867 398,1002 336,1002 278,914 221,1002"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "427,1002 427,745 479,745 479,958 609,958 609,1002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M632 918l51 -5c3,17 9,30 19,38 9,8 21,12 37,12 17,0 30,-4 38,-11 9,-7 13,-16 13,-25 0,-6 -2,-11 -5,-16 -4,-4 -10,-8 -19,-11 -6,-2 -20,-6 -42,-11 -28,-7 -47,-16 -58,-26 -16,-14 -24,-31 -24,-52 0,-13 4,-26 11,-37 7,-12 18,-20 32,-26 14,-6 31,-9 51,-9 32,0 57,7 73,21 16,15 25,34 26,58l-53 2c-2,-14 -7,-23 -14,-29 -7,-6 -18,-9 -33,-9 -15,0 -27,3 -35,9 -6,4 -8,10 -8,16 0,7 2,12 7,16 7,6 23,12 48,18 26,6 44,12 56,18 13,7 22,15 29,26 7,12 10,25 10,42 0,14 -4,28 -12,41 -8,13 -20,23 -35,29 -15,6 -34,10 -56,10 -33,0 -58,-8 -76,-23 -17,-15 -27,-37 -31,-66z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "861,1002 950,867 869,743 930,743 981,820 1032,743 1093,743 1012,867 1101,1002 1038,1002 981,914 923,1002"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#332C2B",
    x: 382,
    y: 448,
    width: 542.578,
    height: 47.8049
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#332C2B",
    x: 382,
    y: 209,
    width: 345.783,
    height: 47.8049
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#332C2B",
    x: 382,
    y: 329,
    width: 542.578,
    height: 47.8049
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFEFE",
    transform: "matrix(1.85407E-014 0.505705 -1 1.9233E-014 578.831 198.885)",
    width: 592.773,
    height: 47.8049
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFEFE",
    transform: "matrix(1.85407E-014 0.505705 -1 1.9233E-014 382.037 198.885)",
    width: 592.773,
    height: 47.8049
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEFEFE",
    transform: "matrix(1.85407E-014 0.505705 -1 1.9233E-014 775.625 206.315)",
    width: 592.773,
    height: 47.8049
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXlsx);
export default __webpack_public_path__ + "static/media/logo_xlsx.5177c572bda9362932ba8ad664d0ad95.svg";
export { ForwardRef as ReactComponent };